<template>
  <div class="upload-box">
    <div class="avatar-uploader-box">
      <!-- 图片预览 -->
      <div :key="index" @mouseover.stop="isShowPopup = true" class="video-preview" v-for="(item, index) in videoList">
        <video :src="item.url" class="avatar">
          您的浏览器不支持视频播放
        </video>
        <!-- 显示查看和删除的按钮弹窗 -->
        <div @mouseleave="isShowPopup = false" v-show="item.url && isShowPopup" class="avatar-uploader-popup">
          <i style="cursor: pointer;" @click="previewVideo(item)" class="el-icon-video-play"></i>
          <i style="cursor: pointer;" @click="deleteVideo(item, index)" class="el-icon-delete"></i>
        </div>
      </div>

      <!-- 方框样式 -->
      <el-upload :action="actionUrl" :auto-upload="false" :on-change="handleAvatarChange" :show-file-list="false"
        class="avatar-uploader el-upload--picture-card" ref="avatarUploader" v-show="uploadShow">
        <span element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-spinner="el-icon-loading"
          element-loading-text="上传中" style="display:block;" v-loading="loading">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </span>
      </el-upload>
    </div>

    <!-- 查看视频-->
    <el-dialog :visible.sync="dialogVisible" append-to-body center title="视频查看">
      <video style="height: 7rem;" :src="videoSrc" ref="video" controls alt width="100%" height="50%">您的浏览器不支持视频播放</video>
    </el-dialog>
  </div>
</template>

<script>
import WholeApi from "@/components/Api/wholeApi";
export default {
  name: 'UploadVideo',
  components: {},
  props: {
    parentId: {
      type: String,
      default: '0'
    },
    numLimit: {
      // 最大允许上传个数
      type: Number,
      default: 1
    },
    sizeLimit: {
      // 最大单文件大小
      type: Number,
      default: 50
    },
    apply: {
      //是否可以操作
      type: Boolean,
      default: true
    },
    // oss路径
    ossRoute: {
      type: String,
      default: () => {
        return "";
      },
    },
    ossPath: {
      type: String,
      default: () => {
        return "resource";
      },
    },
    flodName: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      isShowPopup: false,
      videoList: [],
      videoSrc: '',
      actionUrl: ''
    }
  },
  computed: {
    uploadShow() {
      return this.videoList.length < this.numLimit
    }
  },
  created() { },
  methods: {
    beforeUpload() {
      return false
    },
    // 上传之前
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        console.log(file.raw.type, '撒打算大撒打算大');
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov', 'video/quicktime'].indexOf(file.raw.type) == -1) {
          return reject('请上传正确的视频格式!')
        }

        if (file.size / 1024 / 1024 > this.sizeLimit) {
          return reject(`视频大小不能超过${this.sizeLimit}M!`)
        }

        if (this.videoList.length === this.numLimit) {
          return reject(`最多上传${this.numLimit}个视频`)
        }
        if (!this.apply) {
          return reject(`无法进行操作`)
        }
        resolve('符合表單規則')
      })
    },
    //默认回显
    queryPics(id) {
      if (this.parentId != 0 || id) {
        let parentId = id ? id : this.parentId;
        let arr;
        if (this.flodName) {
          arr = [parentId, "&" + this.flodName];
        } else {
          arr = [parentId];
        }
        new WholeApi(this.ossPath)
          .factoryApi()
          .queryPicByParentIds(arr)
          .then((res) => {
            if (res.status === 200) {
              this.videoList = res.data
              console.log(res.data, '看看回显示的时间');
            }
          });
      }
    },
    
    // 上传改变
    async handleAvatarChange(file, fileList) {
      try {
        await this.beforeAvatarUpload(file)
        this.uploadImgApi(file)
      } catch (e) {
        this.$message.warning(JSON.stringify(e))
      }
    },
    // 上传视频准备
    uploadImgApi(data) {
      const videoSrc = URL.createObjectURL(data.raw)
      this.videoList.push({
        name: data.name,
        videoFile: data,
        flodName: this.flodName,
        url: videoSrc,
      })
      this.$emit('change', this.videoList)
    },
    // 预览视频
    previewVideo(data) {
      this.videoSrc = data.url
      this.dialogVisible = true
    },
    //上传视频，并调用接口
    videoUpload(fileList, linkId) {
      if (linkId != 0 && linkId) {
        return new Promise((resovle, reject) => {
          console.log("将要上传的文件", fileList, this.ossPath);
          let _that = this;
          fileList
            .filter((x) => x.url.indexOf("blob:") !== -1)
            .forEach((item) => {
              const xhr = new XMLHttpRequest();
              xhr.open("GET", item.url); // blob:http://localhost:8080/da126298-1b6b-4dfb-8a92-2e3ccbee611d
              xhr.responseType = "blob";
              xhr.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                  const imageBlob = this.response;
                  const imageType = imageBlob.type;
                  // 上传 Blob 图片
                  const form = new FormData();
                  form.append("file", imageBlob, item.name); // 第三个参数为文件名
                  form.append("parentId", linkId);
                  form.append("flodName", item.flodName);
                  form.append("ossPath", _that.ossRoute);
                  console.log("将要上传的文件11", form, _that.ossPath);
                  new WholeApi(_that.ossPath)
                    .factoryApi()
                    .uploadSingle(form)
                    .then((res) => {
                      if (res.status === 200) {
                        resovle(res.data);
                      }
                    });
                }
              };
              xhr.send();
            });
        });
      }
    },
    // 删除视频
    deleteVideo(item, index) {
      if (this.apply) {
        if (item.id) {
          console.log(item, '坎坎坷坷看看');
          return new Promise((resolve, reject) => {
            if (item.id && item.id > 0) {
              new WholeApi(this.ossPath)
                .factoryApi()
                .delFile(item.id)
                .then((res) => {
                  if (res.status === 200) {
                    this.videoList.splice(index, 1)
                    this.$message.success({ message: "删除成功" });
                    resolve(true);
                  }
                });
            }
          });
        } else {
          this.videoList.splice(index, 1)
        }
      }else {
        this.$message.warning({ message: "无法进行删除操作" });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.queryPics();
    }, 500);
  },
}
</script>

<style lang="scss">
$width: 1.48rem;
$height: 1.48rem;

.upload-box {
  .avatar-uploader-box {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    // padding-bottom: 20px;
    min-width: 350px;

    .avatar-uploader {
      .el-upload {
        width: $width;
        height: $height;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        .el-loading-spinner {
          width: $width;
          height: $height;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 0;
          top: 0;

          .el-loading-text {
            margin: 0;
          }
        }
      }

      .avatar-uploader-icon {
        font-size: 0.28rem;
        color: #8c939d;
        width: $width;
        height: $height;
        line-height: 1.4rem;
        text-align: center;
      }
    }

    .video-preview {
      position: relative;
      padding-right: 0.2rem;

      .avatar {
        width: $width;
        height: $height;
        display: block;
        border-radius: 6px;
      }

      .avatar-uploader-popup {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: $width;
        height: $height;
        background: rgba($color: #000000, $alpha: 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;

        i {
          width: 30%;
          text-align: center;
          padding: 0 5%;
          font-size: 24px;
        }
      }
    }
  }
}
</style>


